import React from 'react';
const contents = [{
  emoji: '📘',
  title: '6 Tomos de Primaria',
  desc: 'Del tomo 1 al 6, planificación anual por grado'
}, {
  emoji: '📐',
  title: '6 Tomos de Secundaria',
  desc: 'De 1° a 6° año con enfoque en técnica y salud'
}, {
  emoji: '⚽',
  title: '480 Sesiones Paso a Paso',
  desc: 'Con materiales, gráficos y variantes'
}, {
  emoji: '📊',
  title: 'Evaluaciones y Rúbricas',
  desc: 'Instrumentos de evaluación listos por nivel'
}, {
  emoji: '⚡',
  title: 'Activaciones y Calentamientos',
  desc: 'Dinámicas variadas para empezar cada clase'
}, {
  emoji: '🌱',
  title: 'Higiene y Salud Integrada',
  desc: 'Contenido teórico-práctico sobre hábitos saludables'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 ¿Qué contiene el Pack Educación Física Lista?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}